/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Case_Sensitive_LabelInputs */



/**
* | output |
* | --- |
* | "Case Sensitive" |
*
* @param {Find_Replace_Case_Sensitive_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_case_sensitive_label = /** @type {((inputs?: Find_Replace_Case_Sensitive_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Case_Sensitive_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sensible a la casse")
	if (locale === "de") return /** @type {LocalizedString} */ ("Groß-/Kleinschreibung beachten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Maiuscole e minuscole")
	if (locale === "ru") return /** @type {LocalizedString} */ ("С учетом регистра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Distingue mayúsculas y minúsculas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("区分大小写")
	if (locale === "ja") return /** @type {LocalizedString} */ ("大文字と小文字を区別")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अक्षर संवेदनशील")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Maiúsculas e minúsculas")
	return /** @type {LocalizedString} */ ("Case Sensitive")
});